var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c("div", { staticClass: "app-main-inner-row" }, [
      _c(
        "div",
        { staticClass: "filters" },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": _vm.isZh ? "80px" : "125px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.labelName } },
                    [
                      (_vm.criteriaType === 2 || _vm.criteriaType === 3) &&
                      _vm.seaLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "Seaport",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      (_vm.criteriaType === 2 || _vm.criteriaType === 3) &&
                      _vm.airLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "Airport",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      (_vm.criteriaType === 2 || _vm.criteriaType === 3) &&
                      _vm.railLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "RailwayStation",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "select-type":
                                _vm.selectTypeNames.basic_data_RailwayStation,
                              "callback-params": { key: "criteriaValue" },
                              "callback-method-type": "value",
                              "clear-not-match": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 1 &&
                      _vm.seaLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "SeaCmp",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { seaCmp: true, active: true },
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              },
                              "show-custom-label-in-option": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 1 &&
                      _vm.airLobArray.includes(_vm.lob)
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "AirCmp",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { airCmp: true, active: true },
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              },
                              "show-custom-label-in-option": true
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 4
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "Region",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              "callback-params": { key: "region" },
                              "callback-method-type": "value"
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e(),
                      _vm.criteriaType === 5
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "205px" },
                            attrs: {
                              no: "BookingAgent",
                              filterable: "",
                              multiple: true,
                              "default-multiple-value": _vm.criteriaValues,
                              "options-width": "250px",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Country
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "Add", type: "primary" },
                          on: { click: _vm.add }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "Delete", type: "danger" },
                          on: { click: _vm.remove }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      {
        staticClass: "app-main-inner-row row-grid",
        staticStyle: { "min-height": "400px" }
      },
      [
        _c("cargo-ag-grid", {
          staticStyle: { width: "100%" },
          attrs: {
            "show-side-bar": false,
            "grid-params": _vm.gridParams,
            "grid-options": _vm.gridOptions,
            "column-defs": _vm.columnDefs,
            "row-data": _vm.rowData
          },
          on: {
            "update:gridParams": function($event) {
              _vm.gridParams = $event
            },
            "update:grid-params": function($event) {
              _vm.gridParams = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }